<template>
  <div>
    <div class="row">
      <div class="col-12">
        <page-header
          :page="page"
          @onReturn="() => $router.back()"
          :has-return="true"
        />
      </div>
    </div>
    <div class="row">
      <div class="col-5">
        <div class="container-process p-3">
          <div class="row">
            <div class="col-4">
              <label class="data-name">Informe:</label>
              <custom-drop-down
                fieldkey="id"
                fieldname="name"
                :disabled="true"
                v-model="dropDownValue"
              />
            </div>
            <div class="col-4">
              <action-button
                @click="process()"
                :i="'fa fa-sync'"
                class=" mt-4 ml-5 positionButton"
                variant="success"
              >
                Procesar
              </action-button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PageHeader from 'PageHeader';
import ActionButton from 'ActionButton';
import ReportServices from '@/modules/report/api';
import DocumentServices from '@//modules/report/document';
import CustomDropDown from 'custom-drop-down';
export default {
  components: {
    PageHeader,
    ActionButton,
    CustomDropDown,
  },
  data: () => ({
    page: {
      icon: 'fas fas fa-chart-pie',
      title: 'Reporte Evaluaciones SAEE',
      routes: ['Informes', 'Reporte Evaluaciones SAEE'],
    },
    dropDownValue: null,
  }),
  computed: {},
  mounted() {
    this.dropDownValue = {
      id: 0,
      name: 'Evaluaciones SAEE',
      directoryName: 'student-evaluation-saee-reports',
      fileName: 'RPT_StudentEvaluationSAEE.xlsx',
    };
  },
  methods: {
    async process() {
      const { directoryName, fileName } = this.dropDownValue;
      await ReportServices.getReport('rpt-evaluationsaee', {
        DirectoryName: directoryName,
        ReportName: fileName,
        FileName: fileName,
      })
        .then((res) => DocumentServices.Download(res.data))
        .catch((err) => {
          this.ShowToast('', err.response?.data?.message, 'error');
        });
    },
  },
};
</script>
<style scoped>
.container-process {
  height: 100px;
  width: 100%;
  background-color: #f4f6f3;
  border-radius: 7px;
}
</style>
